// Angular
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit
} from '@angular/core';
import {
  FormGroup,
  ReactiveFormsModule
} from '@angular/forms';
import { CommonModule, } from '@angular/common';

// Material
import { MatCheckboxModule } from '@angular/material/checkbox';

// Local library
import { IAccountsACH, WithdrawOnlineCheckService } from '@amwager/funding/data-access';
import { UnsubscribeObservableService,
  TranslatePipe
} from '@amwager/util';

// Third party
import { Observable, of, Subscription, takeUntil } from 'rxjs';

@Component({
  selector: 'feature-mat-online-check-withdraw',
  templateUrl: './online-check.component.html',
  styleUrls: ['./online-check.component.scss'],
  imports: [
    CommonModule,
    MatCheckboxModule,
    ReactiveFormsModule,
    TranslatePipe
  ],
  standalone: true,
  providers: [WithdrawOnlineCheckService],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OnlineCheckComponent extends UnsubscribeObservableService implements OnInit {

  onlineCheckForm!: FormGroup;
  // convenience getter for easy access to form fields.
  get formVal() { return this.onlineCheckForm?.controls }
  private subsWithdrawOnlineCheckResponse!: Subscription;
  private subsGetAccountResponse!: Subscription;
  private tmsId?: string;

  amount!: number;
  balance!: number;
  isProcessing = false;
  isAgree = false;
  accountId!: string;
  accounts$!: Observable<IAccountsACH[]>;

  isOnline: boolean = true;

  constructor(
    private readonly elementRef: ElementRef,
    private readonly cdRef: ChangeDetectorRef,
    private readonly onlineCheckService: WithdrawOnlineCheckService,
  ) {
    super();
  }

  ngOnInit() {
    this.checkConnectivity();
    this.observerTmsIds();

    // OLD (moved to WithdrawOnlineCheckService.buildForm):
    // this.initForm();
    this.onlineCheckForm = this.onlineCheckService.buildForm();

    this.amount;
    this.balance = 0;

    // OLD (moved to WithdrawOnlineCheckService.balance$):
    // this.accountFacade.getBalance$().subscribe((balance) => {
    this.onlineCheckService.balance$().subscribe((balance) => {
      if (!balance) return;

      this.balance = balance;
      this.cdRef.markForCheck();
    });

    // OLD (getAchAccount + list stream moved to WithdrawOnlineCheckService.loadAccounts$):
    // this.fundingFacade.getAchAccount();
    // this.subsGetAccountResponse = this.fundingFacade.getAchAccountList$()
    this.subsGetAccountResponse = this.onlineCheckService.loadAccounts$()
      .pipe(takeUntil(this.toUnsubscribe$))
      .subscribe((response) => {

        if (response !== undefined)
          this.accounts$ = of(response);

        this.cdRef.markForCheck();
      });

  }

  showAlertMessage(header: string, message: string): void {
    // OLD (moved to WithdrawOnlineCheckService.showAlert):
    // this.matNotificationService.showAlert(header, message, undefined, undefined, 'Close');
    this.onlineCheckService.showAlert(header, message);
  }

  withdrawAmount(): void {
    this.amount = this.formVal['amount']?.value;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  chooseAccount(account: string, accountId: any): void {

    const accountRows = this.elementRef.nativeElement.querySelectorAll(
      '.choose-account-list .row .selector'
    );
    accountRows.forEach((accountRow: HTMLElement) => {
      accountRow.classList.remove('active');
    });

    const accountRow = this.elementRef.nativeElement.querySelector(
      '.choose-account-list .row #' + account
    );

      if (accountRow.classList.contains('active')) {
        accountRow.classList.remove('active');
        this.accountId = '';
      }
      else {
        accountRow.classList.add('active');
        this.accountId = accountId;
      }
  }

  withdraw(): void {
    if (!this.isOnline) {
      // OLD (moved to WithdrawOnlineCheckService.setOffline):
      // this.commonFacade.setIsConnectedInternet('OnlineCheckComponent:withdraw', false);
      this.onlineCheckService.setOffline('OnlineCheckComponent:withdraw');
      return;
    }

    if (this.onlineCheckForm.valid && this.amount && this.accountId && this.isAgree) {
      this.isProcessing = true;

      // OLD (dispatch + success stream moved to WithdrawOnlineCheckService.withdraw$):
      // this.fundingFacade.withdrawOnlineCheck(this.amount, this.accountId, this.tmsId);
      // this.subsWithdrawOnlineCheckResponse = this.fundingFacade.isWithdrawOnlineCheckSuccess$()
      this.subsWithdrawOnlineCheckResponse = this.onlineCheckService.withdraw$(this.amount, this.accountId, this.tmsId)
      .pipe(takeUntil(this.toUnsubscribe$))
      .subscribe(({response, isSuccess}) => {
        if (!isSuccess && response !== undefined) {
          this.showAlertMessage('Withdraw Error', response.error.Message);
          this.isProcessing = false;
          this.cdRef.markForCheck();
        }

        this.subsWithdrawOnlineCheckResponse?.unsubscribe();

        if (isSuccess) {
          this.showAlertMessage(
            'Successful Withdrawal',
            'ACH Withdrawal successful, transaction will appear in your bank account within 1-3 business days.'
          );
          this.onlineCheckForm.reset();
          this.isAgree = false;
          this.isProcessing = false;
          this.cdRef.markForCheck();
        }
      });
    }
    else {
      // OLD (moved to WithdrawOnlineCheckService.markFormGroupTouched):
      // this.fundingService.markFormGroupTouched(this.onlineCheckForm);
      this.onlineCheckService.markFormGroupTouched(this.onlineCheckForm);
    }
  }

  toggleCheckbox(): void {
    this.isAgree = !this.isAgree;
  }

  private observerTmsIds(): void {
    // OLD (moved to WithdrawOnlineCheckService.tmsId$):
    // this.commonFacade?.tmsId$()
    this.onlineCheckService.tmsId$()
      .pipe(takeUntil(this.toUnsubscribe$))
      .subscribe((tmsId: string | undefined) => {
        this.tmsId = tmsId;
      });
  }

  checkConnectivity(): void {
    // OLD (moved to WithdrawOnlineCheckService.checkConnectivity):
    // this.fundingService.checkConnectivity(
    //   this.environment,
    //   'OnlineCheckComponent:checkConnectivity',
    //   (online: boolean) => this.isOnline = online
    // );
    this.onlineCheckService.checkConnectivity(
      'OnlineCheckComponent:checkConnectivity',
      (online: boolean) => this.isOnline = online
    );
  }

}
